 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}
 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"runtime": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"common":"common","source-add-items-module-add-items-module":"source-add-items-module-add-items-module","source-closeday-module-close-day-module":"source-closeday-module-close-day-module","source-customers-module-customers-module":"source-customers-module-customers-module","source-edit-email-module-edit-email-module":"source-edit-email-module-edit-email-module","source-edit-items-module-edit-item-module":"source-edit-items-module-edit-item-module","source-email-module-email-module":"source-email-module-email-module","source-general_settings-module-general-settings-module":"source-general_settings-module-general-settings-module","source-items-module-items-module":"source-items-module-items-module","source-orders-list-module-orders-list-module":"source-orders-list-module-orders-list-module","source-print-invoice-module-print-invoice-module":"source-print-invoice-module-print-invoice-module","source-print-report-module-print-report-module":"source-print-report-module-print-report-module","source-user-profile_module-profile-module":"source-user-profile_module-profile-module","source-user-users_module-users-module":"source-user-users_module-users-module","source-variants-variant-group_module-variant-group-module":"source-variants-variant-group_module-variant-group-module","default~source-apps-activation-module-apps-activation-module~source-stores-add-store_module-add-stor~4d91b396":"default~source-apps-activation-module-apps-activation-module~source-stores-add-store_module-add-stor~4d91b396","source-apps-activation-module-apps-activation-module":"source-apps-activation-module-apps-activation-module","default~source-stores-add-store_module-add-store-module~source-stores-stores_module-stores-module":"default~source-stores-add-store_module-add-store-module~source-stores-stores_module-stores-module","source-stores-add-store_module-add-store-module":"source-stores-add-store_module-add-store-module","default~source-attendanceReport-module-attendance-report-module~source-dining-kitchen-module-kitchen~0760ef52":"default~source-attendanceReport-module-attendance-report-module~source-dining-kitchen-module-kitchen~0760ef52","source-attendanceReport-module-attendance-report-module":"source-attendanceReport-module-attendance-report-module","source-dining-kitchen-module-kitchen-module":"source-dining-kitchen-module-kitchen-module","source-employee_activity-module-employee-activity-module":"source-employee_activity-module-employee-activity-module","source-item_sales-module-item-sales-module":"source-item_sales-module-item-sales-module","source-sale_summary-module-sale-summary-module":"source-sale_summary-module-sale-summary-module","source-store_summary-module-store-summary-module":"source-store_summary-module-store-summary-module","source-timeclock-module-time-clock-module":"source-timeclock-module-time-clock-module","source-transactions-report-module-transactions-report-module":"source-transactions-report-module-transactions-report-module","default~source-denomination-module-denomination-module~source-import_customers-module-import-custome~4a899029":"default~source-denomination-module-denomination-module~source-import_customers-module-import-custome~4a899029","source-denomination-module-denomination-module":"source-denomination-module-denomination-module","source-import_customers-module-import-customers-module":"source-import_customers-module-import-customers-module","source-import_items-module-import-items-module":"source-import_items-module-import-items-module","source-import_vendors-module-import-vendors-module":"source-import_vendors-module-import-vendors-module","source-payment-module-payment-module":"source-payment-module-payment-module","source-sell-module-sell-module":"source-sell-module-sell-module","default~source-modifiers-modifiers-group-module-modifiers-group-module~source-modifiers-modifiers_mo~4fd2ab00":"default~source-modifiers-modifiers-group-module-modifiers-group-module~source-modifiers-modifiers_mo~4fd2ab00","source-modifiers-modifiers-group-module-modifiers-group-module":"source-modifiers-modifiers-group-module-modifiers-group-module","source-modifiers-modifiers_module-modifiers-module":"source-modifiers-modifiers_module-modifiers-module","default~source-printer-printer-config-printer-config-module~source-printer-printer-group_module-prin~88a6af20":"default~source-printer-printer-config-printer-config-module~source-printer-printer-group_module-prin~88a6af20","source-printer-printer-config-printer-config-module":"source-printer-printer-config-printer-config-module","source-printer-printer-group_module-printer-group-module":"source-printer-printer-group_module-printer-group-module","source-printer-printer_module-printers-module":"source-printer-printer_module-printers-module","source-stores-stores_module-stores-module":"source-stores-stores_module-stores-module","source-404-module-page-not-found-module":"source-404-module-page-not-found-module","source-Inventory-count-module-inventory-count-module":"source-Inventory-count-module-inventory-count-module","source-Inventory-mass-module-mass-inventory-module":"source-Inventory-mass-module-mass-inventory-module","source-Inventory-receive-module-receive-inventory-module":"source-Inventory-receive-module-receive-inventory-module","source-Inventory-return-module-return-inventory-module":"source-Inventory-return-module-return-inventory-module","source-approval-module-devices-module":"source-approval-module-devices-module","source-apps-module-apps-module":"source-apps-module-apps-module","source-business_type-module-business-type-module":"source-business_type-module-business-type-module","source-categories-module-categories-module":"source-categories-module-categories-module","source-daycloseprint-day-close-print-day-close-print-module":"source-daycloseprint-day-close-print-day-close-print-module","source-denied-module-denied-module":"source-denied-module-denied-module","source-departments-module-departments-module":"source-departments-module-departments-module","source-dining-dining-section-module-dining-module":"source-dining-dining-section-module-dining-module","source-dining-serving-module-serving-module":"source-dining-serving-module-serving-module","source-dining-settings-apps_settings-module-setting-module":"source-dining-settings-apps_settings-module-setting-module","source-dining-settings-dispatch_screen-module-dispatch-module":"source-dining-settings-dispatch_screen-module-dispatch-module","source-dining-table-module-table-module":"source-dining-table-module-table-module","source-dining-token-module-token-module":"source-dining-token-module-token-module","source-drivers-module-drivers-module":"source-drivers-module-drivers-module","source-home-module-home-module":"source-home-module-home-module","source-inventory_snapshot-module-inventory-snapshot-module":"source-inventory_snapshot-module-inventory-snapshot-module","source-invoice_credit-module-invoice-credit-module":"source-invoice_credit-module-invoice-credit-module","source-invoice_refund-module-invoice-refund-module":"source-invoice_refund-module-invoice-refund-module","source-item_refund-module-item-refund-module":"source-item_refund-module-item-refund-module","source-items-fodi-eat-info-module-fodi-eat-info-module":"source-items-fodi-eat-info-module-fodi-eat-info-module","source-loyality-module-loyality-program-module":"source-loyality-module-loyality-program-module","source-permissions-module-permission-module":"source-permissions-module-permission-module","source-promotions-module-promotions-module":"source-promotions-module-promotions-module","source-reason-module-reason-module":"source-reason-module-reason-module","source-roles-module-roles-module":"source-roles-module-roles-module","source-switch_store-module-switch_store-module":"source-switch_store-module-switch_store-module","source-tax-module-tax-module":"source-tax-module-tax-module","source-theme-module-theme-module":"source-theme-module-theme-module","source-uom-module-uom-module":"source-uom-module-uom-module","source-vandors-module-vandors-module":"source-vandors-module-vandors-module"}[chunkId]||chunkId) + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							var error = new Error('Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')');
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
